export const getHostName = (urlString) => {
  const parsedUrl = new URL(urlString);
  return parsedUrl.hostname.split('.')[0];
};
